import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11e2584c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid form-background my-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row text-center" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row py-2" }
const _hoisted_6 = { class: "col-6 text-start px-6" }
const _hoisted_7 = { class: "error-msg" }
const _hoisted_8 = { class: "col-6 text-end px-6" }
const _hoisted_9 = { class: "error-msg" }
const _hoisted_10 = { class: "row py-2" }
const _hoisted_11 = { class: "col-6 text-start px-6" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "individual" }, "Individual")
], -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "advisor" }, "Advisor")
], -1))
const _hoisted_18 = { class: "col-6 text-end px-6" }
const _hoisted_19 = { class: "error-msg" }
const _hoisted_20 = { class: "row py-2" }
const _hoisted_21 = { class: "col-6 text-start px-6" }
const _hoisted_22 = { class: "error-msg" }
const _hoisted_23 = { class: "col-6 text-end px-6" }
const _hoisted_24 = { class: "error-msg" }
const _hoisted_25 = { class: "row py-2" }
const _hoisted_26 = { class: "col px-6" }
const _hoisted_27 = { class: "error-msg" }
const _hoisted_28 = { class: "row py-2" }
const _hoisted_29 = { class: "col text-end px-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString($props.title), 1),
          _createElementVNode("h6", null, _toDisplayString($props.subtitle), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.firstName) = $event)),
            placeholder: "First Name",
            onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.v$.firstName.$touch && $setup.v$.firstName.$touch(...args)))
          }, null, 544), [
            [_vModelText, $setup.state.firstName]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.firstName.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.$uid,
              class: "input-errors"
            }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.lastName) = $event)),
            placeholder: "Last Name",
            onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.v$.lastName.$touch && $setup.v$.lastName.$touch(...args)))
          }, null, 544), [
            [_vModelText, $setup.state.lastName]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.lastName.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.$uid,
              class: "input-errors"
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                id: "individual",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.rolePicked) = $event)),
                type: "radio",
                value: "Individual",
                onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.v$.rolePicked.$touch && $setup.v$.rolePicked.$touch(...args)))
              }, null, 544), [
                [_vModelRadio, $setup.state.rolePicked]
              ])
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                id: "advisor",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.rolePicked) = $event)),
                type: "radio",
                value: "Advisor",
                onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.v$.rolePicked.$touch && $setup.v$.rolePicked.$touch(...args)))
              }, null, 544), [
                [_vModelRadio, $setup.state.rolePicked]
              ])
            ]),
            _hoisted_17
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.firmName) = $event)),
            placeholder: "Firm Name",
            onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.v$.firmName.$touch && $setup.v$.firmName.$touch(...args)))
          }, null, 544), [
            [_vModelText, $setup.state.firmName]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.firmName.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.$uid,
              class: "input-errors"
            }, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.state.phoneNumber) = $event)),
            placeholder: "Phone #",
            onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.v$.phoneNumber.$touch && $setup.v$.phoneNumber.$touch(...args)))
          }, null, 544), [
            [_vModelText, $setup.state.phoneNumber]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.phoneNumber.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.$uid,
              class: "input-errors"
            }, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(error.$message) + ".", 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_23, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.state.emailAddress) = $event)),
            placeholder: "Email Address",
            onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($setup.v$.emailAddress.$touch && $setup.v$.emailAddress.$touch(...args)))
          }, null, 544), [
            [_vModelText, $setup.state.emailAddress]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.emailAddress.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.$uid,
              class: "input-errors"
            }, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.state.message) = $event)),
            class: "additonal-info-textbox",
            placeholder: "Additional Information",
            onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => ($setup.v$.message.$touch && $setup.v$.message.$touch(...args)))
          }, null, 544), [
            [_vModelText, $setup.state.message]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.message.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.$uid,
              class: "input-errors"
            }, [
              _createElementVNode("div", _hoisted_27, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("a", null, [
            _createVNode(_component_SecondaryButton, {
              text: "Submit",
              outlined: "true",
              "min-width": "192px",
              class: _normalizeClass({ valid: !$setup.v$.$error && $setup.v$.$dirty, error: $setup.v$.$error }),
              "on-click": $options.sendEmailToServer($setup.state, $setup.v$)
            }, null, 8, ["class", "on-click"])
          ])
        ])
      ])
    ])
  ]))
}